import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import useAuth from "@/lib/auth/useAuth";
import { Resource } from "@/types/user";
import { useEffect } from "react";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/treatment-sectors",
)({
    component: TreatmentSectorsLayout,
});

function TreatmentSectorsLayout() {
    const { isAtLeastDetail } = useAuth();
    const navigate = useNavigate();
    const { fieldId } = Route.useParams();

    useEffect(() => {
        if (!isAtLeastDetail(Resource.TREATMENT_SECTORS)) {
            navigate({
                to: "/dashboard/fields/$fieldId/setup",
                params: { fieldId },
                replace: true,
            });
        }
    }, [isAtLeastDetail, navigate, fieldId]);

    if (!isAtLeastDetail(Resource.TREATMENT_SECTORS)) return null;
    return <Outlet />;
}
